const func = ($target) => {
    let header = document.querySelector(".header-cta-bar"),
        toggleClass = "is-sticky",
        stickyPixel = $target.find('.stickyPixel').html();

    window.addEventListener("scroll", () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll > stickyPixel) {
            header.classList.add(toggleClass);
        } else {
            header.classList.remove(toggleClass);
        }
    });

}

export default func;